export const SPECIAL_KEY = "c@(%vGEmh]K<w846U"